import React, { useState, lazy } from 'react';
import { Divider, InputBase, IconButton, Typography } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Search as SearchIcon } from '@mui/icons-material';
import Building from './pages/buildings/Building';

import SearchResults from './components/search/SearchResults';
import BuildingCard from './components/building/BuildingCard';

import useStores from './stores/useStores';

const MapContainer = lazy(() => import('./components/map/MapContainer'));

const Demo = ({ props }) => {
  const history = useHistory();
  const { buildingStore, buildingDetailStore } = useStores();
  const match = props?.match;
  const { buildingId } = match.params;
  const [present, setPresent] = useState(false);

  const [showSearch, setShowSearch] = useState(true);
  let state = {
    y: 16,
    opacity: 1
  };
  if (showSearch)
    state = {
      y: 16,
      opacity: 1
    };
  if (!showSearch)
    state = {
      y: '90vh',
      opacity: 1
    };
  if (!showSearch && buildingId)
    state = {
      y: '90vh',
      opacity: 1
    };
  return (
    <div
      className="demo"
      style={{
        width: '100%'
      }}
    >
      <div
        style={{
          width: '100%',
          top: 0,
          height: '100%',
          position: 'fixed'
        }}
      >
        <MapContainer {...props} />
      </div>
      <div
        role="presentation"
        className="demo-container"
        style={{
          height: '100vh',
          width: '100%',
          overflow: 'scroll',
          position: 'absolute',
          cursor: present ? 'pointer' : 'default'
        }}
        onClick={event => {
          if (event.target === event.currentTarget) {
            if (!showSearch) {
              document
                .querySelector('.demo-container')
                .scrollTo({ top: 0, behavior: 'smooth' });

              setShowSearch(true);
              setPresent(false);
            }
          }

          /*
          setStyles({
            ...styles,
            container: {
              transform: `translateY(calc(100vh - 90px))`
            }
          });
          */
        }}
      >
        <div
          style={{
            // height: '100vh',
            width: '960px',
            margin: 'auto',
            position: 'relative',
            // paddingTop: 380,
            zIndex: 1000
            // transform: `translateY(16px)`
            // transform: `translateY(calc(100vh - 96px));`,
            // transition: 'all ease-in-out 0.2s'
          }}
        >
          <motion.div
            key="search"
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: 1, ...state }}
            transition={{ ease: 'easeOut', duration: 0.3 }}
            exit={{ opacity: 0, y: 0 }}
          >
            <div className="search-container">
              <div className="search-controls" elevation={1}>
                <InputBase
                  // value={value}
                  onClick={event => {
                    setShowSearch(true);
                    event.stopPropagation();
                    /*
                  setStyles({
                    ...styles,
                    container: {
                      transform: `translateY(16px)`
                    }
                  });
                  */
                  }}
                  onChange={event => {
                    buildingStore.setFilter('addresses', event.target.value);
                  }}
                  sx={{
                    fontSize: 48,
                    padding: 0,
                    width: '100%'
                  }}
                  className="search-controls-input"
                  placeholder="Search..."
                  startAdornment={
                    <IconButton
                      disabled
                      color="default"
                      style={{
                        width: 48,
                        marginRight: 16,
                        height: 48,
                        fontSize: 48
                      }}
                      sx={{
                        largeIcon: {
                          fontSize: 48
                        }
                      }}
                      onClick={() => {}}
                      size="extraLarge"
                    >
                      <SearchIcon />
                    </IconButton>
                  }
                />
              </div>
              <Divider />
              <SearchResults
                style={{
                  position: 'static',
                  width: '100%',
                  height: '100%',
                  flexGrow: 1,
                  flex: 1
                }}
                getItemsSize={() => {
                  return 90;
                }}
                renderNoResults={() => {
                  return (
                    <>
                      <div className="search-result results results-none">
                        {buildingStore.filters?.addresses?.length && (
                          <Typography variant="h5">No results</Typography>
                        )}
                        {!buildingStore.filters?.addresses?.length && (
                          <Typography variant="h5">
                            Type an address into the search bar to begin.{' '}
                          </Typography>
                        )}
                      </div>
                    </>
                  );
                }}
                renderRow={({ index, style, data }) => (
                  <div className="search-result" key={index} style={style}>
                    <BuildingCard
                      disableGrade
                      onClick={event => {
                        (async () => {
                          await buildingDetailStore.loadBuilding(data.id);
                          setPresent(true);
                          setShowSearch(false);
                        })();
                        event.stopPropagation();
                        history.push(`/demo/${data.id}`);
                      }}
                      // to={`/demo/${data.id}`}
                      building={data}
                    />
                  </div>
                )}
                store={buildingStore}
              />
            </div>
          </motion.div>
          <div
            role="presentation"
            onClick={event => {
              if (event.target === event.currentTarget) {
                setShowSearch(true);
                setPresent(false);
              }
            }}
            className="building-container"
          >
            <AnimatePresence>
              {present && (
                <motion.div
                  key="building"
                  transition={{ ease: 'easeOut', duration: 0.3 }}
                  initial={{ opacity: 1, y: '100vh' }}
                  animate={{ opacity: 1, y: 350 }}
                  exit={{ opacity: 1, y: '100vh' }}
                >
                  <Building
                    noHeader
                    isDemo
                    noHeaderMap
                    style={{
                      cursor: 'default',
                      position: 'static',
                      margin: 'auto',
                      // height: 90000,
                      // overflow: 'hidden',
                      borderTopLeftRadius: 8,
                      // transform: 'translateY(400px)',
                      borderTopRightRadius: 8,
                      boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px'
                    }}
                    history={history}
                    match={{
                      ...match,
                      params: {
                        buildingId: buildingId || 'W167890836'
                      }
                    }}
                  />
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(Demo);
